



































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { inspectors,saveInspector,deleteInspector } from '@/api/team/team'

@Component
export default class Guarantee extends Vue {

    private dataList: object[] = [];
    private total: number | string = 0;
    private formData: object = {
        uid: '',
    };
    private ruleValidate: object = {
        uid: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
    };
    private visible:boolean = false
    private searchParams: object = {
        uid:'',
        page: '1',
        pagesize: '20',
    };
    private columnsSchema: object[] = [
        {
            title: '头像',
            slot: 'url',
            align: 'center',
        },
        {
            title: '审查员ID',
            key: 'uid',
            align: 'center',
        },
        {
            title: '昵称',
            key: 'nick_name',
            align: 'center',
        },
        {
            title: '通过时间',
            slot: 'ctime',
            align: 'center',
        },
        {
            title: '操作',
            slot: 'operate',
            align: 'center',
        },
    ];
    @Watch('$route')
    private routechange(to: any, from: any) {
        if (to.name == 'empower') {
            this.getList();
        }
    }
    private created() {
        this.getList()
    }
    private async getList() {
        let params: any = JSON.parse(JSON.stringify(this.searchParams))
        try {
            const data = (await inspectors(params)) as any;
            this.$nextTick(() => {
                this.dataList = data.rows;
                this.total = data.total;
            });
        } catch (error) {
            console.log(error);
        }
    }

    // 搜索
    private handleSearch() {
        this.getList();
    }
    // 开始日期选择器
    private stimeChange(date){
        (this.searchParams as any).stime = date
    }
    // 开始日期选择器
    private etimeChange(date){
        (this.searchParams as any).etime = date
    }
    // 分页
    private changePage(data) {
        this.searchParams = Object.assign(this.searchParams, {
            page: data,
        });
        this.getList();
    }
    // 重置
    private handlereset() {
        this.searchParams = {
            uid:'',
            page: '1',
            pagesize: '20',
        };
        this.getList();
    }
    // 删除审查员
    private async handleDeleteMember(uid){
        let res:any = await  deleteInspector({uid:uid});
        this.getList()
    }
    // 显示新增弹窗
    private showModal(){
        this.visible = true
    }
    private handleCancel() {
        this.visible = false
    }
    // 新增表单验证
    private handleValidate() {
        (this.$refs.formValidate as any).validate(valid => {
            if (valid) {
                this.handleAdd();
            } else {
                return false;
            }
        });
    }
    //增加审核员
    private async handleAdd(){
        let res = await saveInspector(this.formData)
        this.visible = false;
        this.getList()
    }
}
